<template>
<div>
    <div class="alert alert-danger mt-10 mb-30" role="alert"
         v-show="hasErrors()">
        <b>Please correct the following errors:</b>
        <ul>
            <li v-for="error in errors.entries.class_date">{{ error }}</li>
            <li v-for="error in errors.entries.class_work">{{ error }}</li>
            <li v-for="error in errors.entries.home_work">{{ error }}</li>
            <li v-for="error in errors.global_errors">{{ error }}</li>
        </ul>
    </div>

    <table class="daily-lessons dataTable table table-striped">
        <tbody>
        <tr v-for="(entry, index) in entries" :key="index">
            <td>
                <div class="row px-20 mb--20">

                    <!-- Class Date -->
                    <div class="form-field-container col-md-12 col-lg-4 col-xxl-4">
                        <FormElement label="Date"
                                     :label-for-id="`class_date-${index}`"
                                     label-class="required">
                            <DatePicker :required="true"
                                        :reference="index.toString()"
                                        :on-change="onDateChanged"
                                        :value="entry.class_date ? moment(entry.class_date, 'DD-MM-YYYY').toDate() : moment().toDate()"
                                        :error="errors.entries.class_date[index]"/>
                        </FormElement>
                    </div>

                    <!-- Class Work -->
                    <div class="form-field-container col-md-12 col-lg-4 col-xxl-4">
                        <FormElement :error="errors.entries.class_work[index]"
                                     :label="getLabel('Class Work')"
                                     :label-for-id="`class_work-${index}`"
                                     label-class="required">
                            <textarea :id="`class_work-${index}`"
                                   type="text"
                                   rows="2"
                                   class="form-control"
                                   v-bind:class="{ 'is-invalid' : errors.entries.class_work[index] }"
                                   v-model="entry.class_work"
                                   required="required"/>
                        </FormElement>
                    </div>

                    <!-- Home Work or activities -->
                    <div class="form-field-container col-md-12 col-lg-3 col-xxl-3">
                      <FormElement :error="errors.entries.home_work[index]"
                                   :label="getLabel('Home Work')">
                        <template v-if="school.id === 57">
                          <select class="form-control"
                                  :id="`activity-${index}`"
                                  v-model="entry.home_work"
                                  :class="{ 'is-invalid' : errors.entries.home_work[index] }">
                            <option value="">Select...</option>
                            <option v-for="activity in activities" :key="activity" :value="activity">
                              {{ activity }}
                            </option>
                          </select>
                        </template>
                        <template v-else>
                          <textarea :id="`home_work-${index}`"
                                    type="text"
                                    rows="2"
                                    class="form-control"
                                    v-bind:class="{ 'is-invalid' :  errors.entries.home_work[index] }"
                                    v-model="entry.home_work"/>
                        </template>
                      </FormElement>
                    </div>

                  <!-- Online Exam -->
                  <div v-if="school.id === 101"
                      class="form-field-container col-md-12 col-lg-4 col-xxl-4"
                  >
                    <FormElement :error="errors.entries.online_exam[index]"
                                 :label="getLabel('Online Exam for Next Class')"
                                 :label-for-id="`online_exam-${index}`"
                    >
                            <textarea :id="`online_exam-${index}`"
                                      type="text"
                                      rows="2"
                                      class="form-control"
                                      v-bind:class="{ 'is-invalid' : errors.entries.online_exam[index] }"
                                      v-model="entry.online_exam"
                                      required="required"/>
                    </FormElement>
                  </div>

                  <!-- Offline Exam -->
                  <div v-if="school.id === 101"
                      class="form-field-container col-md-12 col-lg-4 col-xxl-4"
                  >
                    <FormElement :error="errors.entries.offline_exam[index]"
                                 :label="getLabel('Offline Exam for Next Class')"
                                 :label-for-id="`offline_exam-${index}`"
                    >
                            <textarea :id="`offline_exam-${index}`"
                                      type="text"
                                      rows="2"
                                      class="form-control"
                                      v-bind:class="{ 'is-invalid' : errors.entries.offline_exam[index] }"
                                      v-model="entry.offline_exam"/>
                    </FormElement>
                  </div>

                  <!-- Memory Test -->
                  <div v-if="school.id === 101"
                      class="form-field-container col-md-12 col-lg-3 col-xxl-3"
                  >
                    <FormElement :error="errors.entries.memory_test[index]"
                                 :label="getLabel('Memory Test for Next Class')"
                                 :label-for-id="`memory_test-${index}`"
                    >
                            <textarea :id="`memory_test-${index}`"
                                      type="text"
                                      rows="2"
                                      class="form-control"
                                      v-bind:class="{ 'is-invalid' : errors.entries.memory_test[index] }"
                                      v-model="entry.memory_test"/>
                    </FormElement>
                  </div>

                    <!-- Action - Delete -->
                    <div class="form-field-container col-md-1 col-lg-1">
                        <FormElement label="">
                            <ActionButtons :entry="entry"
                                           :index="index"
                                           :remove-entry="removeEntry"/>
                        </FormElement>
                    </div>

                </div>
            </td>
        </tr>
        </tbody>
    </table>

    <div class="mt-30">

        <!-- Add Entry -->
        <button id="add-entry-btn" type="button"
                class="btn btn-outline btn-primary w-120 mb-20" @click="addEntry">
            <i class="fa fa-plus"></i>
            <span class="text ml-5">Add Entry</span>
        </button>

        <!-- Submit -->
        <button type="button" class="d-block ladda-button btn btn-primary mb-20 w-120"
                data-app-plugin="ladda" data-style="expand-left" id="account-records-submit-btn"
                @click="submit($event)">
            Submit
        </button>

    </div>
</div>
</template>

<script>
import {ref} from 'vue';
import moment from "moment";
import FormElement from '../../components/FormElement';
import DatePicker from "../../components/DatePicker";
import ActionButtons from "./components/ActionButtons";

export default {
    components: {
        DatePicker,
        FormElement,
        ActionButtons,
    },
    props: {
      school: {
        type: Object,
        required: true,
      },
      activities: {
        type: Object,
        required: false,
      },
    },
    setup(props) {
        return {
            entries: ref([]),
            errors: ref({
                entries: {
                    class_date: {},
                    class_work: {},
                    home_work: {},
                    online_exam: {},
                    offline_exam: {},
                    memory_test: {},
                },
                global_errors: []
            }),
        }
    },
    methods: {
        moment(date, format) {
            moment.locale('en')
            return date ? moment(date, format) : moment()
        },
        hasErrors() {
            return Object.entries(this.errors.entries.class_date || {}).length > 0
                || Object.entries(this.errors.entries.class_work || {}).length > 0
                || Object.entries(this.errors.entries.home_work || {}).length > 0
                || this.errors.global_errors.length > 0
        },
        getLabel(label) {
          switch (label) {
            case 'Home Work':
              return this.school.id === 57 ? 'Activities' : label;
            case 'Class Work':
              return this.school.id === 57 ? 'Lesson In Details' : label;
            default:
              return label;
          }
        },
        onDateChanged(ref, date) {
            this.entries[ref].class_date = date
        },
        addEntry() {
            this.entries.push({
                class_date: this.entries[this.entries.length - 1]?.class_date,
                class_work: '',
                home_work: '',
            })
        },
        removeEntry(index) {
            this.entries.splice(index, 1)
        },
        async submit() {

            let formData = {
                'session': document.querySelector('#session').value || null,
                'branch': document.querySelector('#branch').value || null,
                'shift': document.querySelector('#shift').value || null,
                'class': document.querySelector('#class').value || null,
                'section': document.querySelector('#section').value || null,
                'subject': document.querySelector('#subject').value || null,
                'class_dates': this.entries.map(entry => entry.class_date || null),
                'class_works': this.entries.map(entry => entry.class_work || null),
                'home_works': this.entries.map(entry => entry.home_work || null),
                'online_exams': this.entries.map(entry => entry.online_exam || null),
                'offline_exams': this.entries.map(entry => entry.offline_exam || null),
                'memory_tests': this.entries.map(entry => entry.memory_test || null),
            };

            fetch(route('daily-lessons.store'),
                {
                    method: 'post',
                    headers: new Headers({
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
                        'X-Requested-With': 'XMLHttpRequest',
                        'Content-Type': 'application/json'
                    }),
                    credentials: 'include',  // adds cookie header
                    body: JSON.stringify(formData)
                }
            ).then(async response => {
                if (response.status === 422) {
                    const json = await response.json()
                    this.showSubmissionErrors(this.transformSubmissionErrors(json.errors))
                    window.Ladda.stopAll()
                } else if (!response.ok) {
                    const error = await response.text()
                    toastr.error(`Failed creating Daily Lessons: ${error}`)
                    window.Ladda.stopAll()
                } else {
                    toastr.success('Daily Lessons Created.')
                    window.location.href = route('daily-lessons.index');
                }
            })
        },
        transformSubmissionErrors(serverSideErrors) {
            const errors = {
                entries: {
                    class_date: {},
                    class_work: {},
                    home_work: {}
                },
                global_errors: []
            }

            for (let prop in serverSideErrors) {
                if (prop.startsWith('entries')) {
                    const propParts = prop.split('.')
                    errors.entries[propParts[2]][propParts[1]] = serverSideErrors[prop][0]
                } else {
                    errors.global_errors.push(serverSideErrors[prop])
                }
            }

            return errors
        },
        showSubmissionErrors(errors) {
            console.log(errors)
            this.errors = errors
            toastr.error(`Please correct the errors specified.`)
            window.scrollTo({top: 0, behavior: 'smooth'})
        }
    },
    mounted() {
        this.addEntry()
    },
}

</script>

<style scoped>
    .dataTable tr:last-child td {
        border-top: 1px solid #3e8ef7 !important;
    }
</style>